import { render, staticRenderFns } from "./list-bsk.vue?vue&type=template&id=49a6b547&scoped=true&"
import script from "./list-bsk.vue?vue&type=script&lang=js&"
export * from "./list-bsk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a6b547",
  null
  
)

export default component.exports